var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1345 17.1248C14.4127 17.1248 16.2595 15.278 16.2595 12.9998C16.2595 10.7217 14.4127 8.87485 12.1345 8.87485C9.85635 8.87485 8.00952 10.7217 8.00952 12.9998C8.00952 15.278 9.85635 17.1248 12.1345 17.1248Z",
    stroke: "white",
    strokeWidth: 2.1347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1346 1.99997C9.21726 1.99997 6.41937 3.15889 4.35647 5.2218C2.29357 7.2847 1.13464 10.0826 1.13464 13C1.13464 15.6015 1.68739 17.3037 3.19714 19.1875L12.1346 29.5L21.0721 19.1875C22.5819 17.3037 23.1346 15.6015 23.1346 13C23.1346 10.0826 21.9757 7.2847 19.9128 5.2218C17.8499 3.15889 15.052 1.99997 12.1346 1.99997V1.99997Z",
    stroke: "white",
    strokeWidth: 2.1347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerIcon);
export default __webpack_public_path__ + "static/media/pointer_icon.211d046e698c22a524547baaa4c2405b.svg";
export { ForwardRef as ReactComponent };